export default "__VITE_ASSET__Dbfiu_tx__"